import { PartialConfig } from '../ygdrasil/types/types'

export function onClickIndicatorTitle(setIsEditing: (isEditing: boolean) => unknown, config: PartialConfig) {
  return () => config.enableEditSuccessView && setTimeout(() => setIsEditing(true))
}
